import listActions from 'src/modules/event/list/eventListActions';
import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENT_CLONE';

const eventCloneActions = {
  CLONE_STARTED: `${prefix}_CLONE_STARTED`,
  CLONE_SUCCESS: `${prefix}_CLONE_SUCCESS`,
  CLONE_ERROR: `${prefix}_CLONE_ERROR`,

  CLONE_ALL_STARTED: `${prefix}_CLONE_ALL_STARTED`,
  CLONE_ALL_SUCCESS: `${prefix}_CLONE_ALL_SUCCESS`,
  CLONE_ALL_ERROR: `${prefix}_CLONE_ALL_ERROR`,
  
  doCloneAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventCloneActions.CLONE_ALL_STARTED,
      });
    
      const result = await EventService.cloneAll(ids);

      dispatch({
        type: eventCloneActions.CLONE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.event.cloneAll.success', result.count),
      );
      
      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventCloneActions.CLONE_ALL_ERROR,
      });
    }
  },
};

export default eventCloneActions;
